import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import styled from 'styled-components'
import { useHookTable } from './hook'
import { FilterLayout } from './layouts'
import { useGetHeightTable } from 'app/hook'
const ReportLeaveContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    filter,
    handleChangeFilter,
    loading,
    pagination,
  } = useHookTable()
  return (
    <S.BaseManagementWrapper>
      <RootWrapper size={4}>
        <FilterLayout formData={filter} onChange={handleChangeFilter} />
        <BaseTableWrapper
          columns={columns}
          dataSource={tableData.data}
          pagination={pagination}
          loading={loading}
          onChange={handleTableChange}
          rowClassName="row-overwrite-style"
          scroll={{
            x: true,
            y: tableData?.data?.length ? useGetHeightTable(250, 30) : undefined,
          }}
        />
      </RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default ReportLeaveContainer

const RootWrapper = styled(BaseSpace)`
  background-color: ${convertedVariables.backgroundColor};
  border-radius: 8px;
`

const BaseTableWrapper = styled(BaseTableManagement)`
  .ant-table-tbody
    > tr
    > td
    > .ant-table-expanded-row-fixed
    > .ant-table-wrapper
    .ant-table {
    margin-block: -16px;
    margin-inline: 32px -16px;
  }

  .child-column {
    color: rgba(0, 34, 68, 0.4) !important;
  }

  .important-column {
    color: ${convertedVariables.statesRedColor} !important;
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:first-child {
    border-radius: 0px !important;
  }

  .ant-table-thead > tr > th {
    font-weight: 600 !important;
    text-align: center !important;
  }

  .hour-month-col {
    min-width: 70px !important;
  }

  .working-hour-month-appointment-hour {
    min-width: 70px !important;
  }

  .working-hour-day-col {
    min-width: 70px !important;
  }

  .appointment-hour-col {
    min-width: 60px !important;
  }

  .rate-col {
    min-width: 60px !important;
  }
`
